<template>
    <section class="tickets-tabs">
        <promocode
            v-if="allowPromocode"
            :submitCallBack="applyPromocode"
            :trans="trans"
        ></promocode>

        <nav class="tabs">
            <location-tab
                @click.native="setActive(location)"
                v-for="(location, k) in locations"
                v-bind:key="k"
                :active="active"
                :location="location"
                :trans="trans.seat"
            >
            </location-tab>
        </nav>

        <form
            :action="config.form_action"
            @submit="handleSubmit"
            id="carn_tkt"
            name="carn_tkt"
            method="post"
        >
            <input type="hidden" name="price_split" :value="split" />
            <input type="hidden" name="promocode" :value="promocode" />
            <div v-bind:class="['tabs-content tab-content-' + active.slug_en]">
                <table-information
                    :location="active"
                    :trans="trans"
                ></table-information>
                <div v-bind:class="['table-wrapper wrapper-' + offday]">
                    <img
                        :src="trans.tickets.champions_banner[active.slug_en]"
                        alt=""
                        v-if="offday === 'off-day-4'"
                    />

                    <table :class="offday">
                        <table-head
                            :offday="offday"
                            :dates="dates"
                            :trans="trans.tickets"
                        ></table-head>
                        <table-body
                            :toggle="toggleTicketsOnBuyList"
                            :config="config"
                            :outlet="isOutlet"
                            :buyList="buyList"
                            :tickets="tickets"
                            :dates="dates"
                            :active="active"
                            :discount="discount"
                            :trans="trans"
                        >
                        </table-body>
                    </table>
                </div>

                <table-submit
                    error=""
                    :name="trans.buttons.tickets.submit"
                ></table-submit>
                <alert :type="alert.type" :message="alert.message"></alert>
            </div>
        </form>
    </section>
</template>

<style lang="scss" scoped>
@import "../../../sass/variables";

.tabs-content {
    display: block;
    width: 100%;
    border-radius: 0 15px 15px 15px;
    margin-bottom: 0;
    padding: 40px 40px 32px;
    background-color: white;
    border: 1px solid var(--color-gray-light);
}

.tickets-tabs {
    border: 1px solid var(--color-gray-light);
    width: 100%;
    max-width: $custom-container-max-width-padding;
    margin: 30px auto 0;
    background: #fff;
    position: relative;
    z-index: 10;
    border-radius: 15px;
}

.tabs {
    display: flex;
    list-style: none;
    width: 100%;
    padding: 0;
    margin: 0;
}

table {
    margin: 20px 0 40px;
    border-collapse: collapse;
    padding: 0;
    width: 100%;
    table-layout: auto;
}
</style>

<script>
import Alert from "../form/AlertForm.vue";
import SvgIcon from "../general/SvgIcon.vue";
import Promocode from "./TicketsPromocode.vue";
import TableBody from "./TicketsTableBody.vue";
import TableHead from "./TicketsTableHead.vue";
import TableInformation from "./TicketsTableInformation.vue";
import LocationTab from "./TicketsTableLocationTab.vue";
import TableSubmit from "./TicketsTableSubmit.vue";

export default {
    props: {
        offday: String,
        split: String,
        config: {
            type: Object,
            required: true
        },
        dates: {
            type: Array,
            required: true
        },
        locations: {
            type: Array,
            required: true
        },
        tickets: {
            type: Object,
            required: true
        },
        trans: {
            type: Object,
            required: true
        }
    },

    components: {
        Alert,
        SvgIcon,
        Promocode,
        LocationTab,
        TableInformation,
        TableHead,
        TableBody,
        TableSubmit
    },

    mounted() {
        this.firstActiveLocation();
    },

    data() {
        return {
            active: {},
            promocode: null,
            discount: null,
            buyList: {},
            alert: {}
        };
    },

    computed: {
        isOutlet() {
            const priceType = this.config.price_type;

            return priceType.toLowerCase().includes("outlet");
        },

        allowPromocode() {
            const allow = this.config.allow_promocode;

            return allow && !this.isOutlet;
        }
    },

    methods: {
        applyPromocode(data) {
            if (!data) {
                this.discount = null;
                this.promocode = null;
                return false;
            }

            this.promocode = data.promocode || null;
            this.discount = data;
        },

        possibleLocationFromURL() {
            const pathname = window.location.pathname;
            const pathnameList = pathname.split("/");
            return pathnameList[pathnameList.length - 1];
        },

        locationMatchesUrl() {
            const possibleLocation = this.possibleLocationFromURL();
            return this.locations.filter(
                location => location.slug === possibleLocation
            );
        },

        setActive(location) {
            const params = window.location.search;

            const pathname =  window.location.pathname.endsWith('/')
                ? window.location.pathname.slice(0, -1)
                : window.location.pathname;

            const possibleLocation = this.possibleLocationFromURL();
            let url = `${pathname}/${location.slug}`;

            if (this.locationMatchesUrl().length > 0) {
                url = pathname.replace(possibleLocation, location.slug);
            }

            this.active = location;
            history.replaceState({}, null, url + params);
            return this.active;
        },

        firstActiveLocation(location) {
            const possibleLocation = this.possibleLocationFromURL();
            const matches = this.locations.filter(
                location => location.slug === possibleLocation
            );
            const hasActiveLocation = this.locationMatchesUrl().length > 0;

            if (hasActiveLocation) {
                return (this.active = matches[0]);
            }

            if (this.locations.length > 0) {
                return this.setActive(this.locations[0]);
            }
        },

        toggleTicketsOnBuyList(ticket) {
            if (typeof this.buyList[ticket.id] !== "undefined") {
                delete this.buyList[ticket.id];
                return true;
            }

            this.buyList = {
                ...this.buyList,
                [ticket.id]: ticket
            };
        },

        handleSubmit(event) {
            const hasTickets = Object.keys(this.buyList).length > 0;

            if (!hasTickets) {
                event.preventDefault();

                this.alert = {
                    type: "error",
                    message: this.trans.tickets.no_items_selected
                };

                return false;
            }

            return true;
        }
    }
};
</script>
